/**
 * 页面三态里的「失败」态。
 *
 * 为什么单独抽出来：后台每个页面都从接口取数，403（权限不足）与 500（系统故障）
 * 必须能一眼分开 —— 权限拦截是权限模型的正常结果，不是错误弹窗。
 */
import type { ReactNode } from 'react';
import { ApiError } from '../lib/api.ts';

export function ErrorBox({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="state-box error">
      <div className="st-ico">⚠</div>
      <div className="st-title">{message}</div>
      {onRetry !== undefined && (
        <button type="button" className="btn sm" onClick={onRetry}>
          重试
        </button>
      )}
    </div>
  );
}

/** 请求失败的统一文案：ApiError 带服务端 message，其余给通用提示。 */
export function errorText(err: unknown): string {
  if (err instanceof ApiError) return err.message;
  if (err instanceof Error) return err.message;
  return '请求失败，请稍后重试';
}

export function LoadingBox({ text = '正在加载…' }: { text?: string }): ReactNode {
  return (
    <div className="state-box">
      <div className="spinner" />
      <div>{text}</div>
    </div>
  );
}

export function EmptyBox({ title, desc }: { title: string; desc?: string }) {
  return (
    <div className="state-box">
      <div className="st-ico">◍</div>
      <div className="st-title">{title}</div>
      {desc !== undefined && <div>{desc}</div>}
    </div>
  );
}
